import { render, staticRenderFns } from "./description-item.vue?vue&type=template&id=18542bba&scoped=true"
import script from "./description-item.vue?vue&type=script&lang=js"
export * from "./description-item.vue?vue&type=script&lang=js"
import style0 from "./description-item.vue?vue&type=style&index=0&id=18542bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18542bba",
  null
  
)

export default component.exports